import { useContext } from "react";
import { DialogContext, DialogContextType } from "../providers/DialogContext";

export const useDialog = (): DialogContextType => {
  const context = useContext(DialogContext);
  if (!context) {
    throw new Error("useData must be used within a DataProvider");
  }
  return context;
};
